<script setup>
import { computed } from 'vue';
import { useStore } from 'vuex';
import { getStandardSplineChartConfig } from 'JIX/highcharts/configs/spline_chart.js';
import { __ } from 'JIX/gettext';
import ChartTabs from './ChartTabs.vue';

const store = useStore();
const data = computed(() => store.state.searchResponse.data.jobadHistory);


function buildConfig(index, usePct) {
    return getStandardSplineChartConfig({
        title: {
            text: __('Udvikling i antallet af jobannoncer over tid')
        },
        plotOptions: {
            series: {
                custom: {
                    usePct,
                },
            },
        },
        tooltip: {
        // Tooltip text formatting.
        // Example html when the series is set to ad count: "Q3 2023: <b>369</b> annoncer".
        // Example html when the series is set to ad pct: "Q3 2023: <b>0,51%</b>".
            formatter: function() {
                const year = Math.floor(this.x);
                const quarter = Math.round(4 * (this.x - year)) + 1;

                let point = '<b>' + this.y + '</b> ' + __('annoncer');
                if (this.series.options.custom.usePct) {
                    // Highcharts is available in this vue app. It is made available in bundles/jobsearch/result_app.js.
                    // eslint-disable-next-line no-undef
                    point = '<b>' + Highcharts.numberFormat(this.y, 2, ',') + '%</b>';
                }

                return 'Q' + quarter + ' ' + year + ': ' + point;
            },
        },
        series: data.value[index].series,
    });
}


</script>

<template>
    <h2
        class="mt-2"
    >
        {{ __('Historik') }}
    </h2>
    <ChartTabs :tabs="data.map(({ title }) => ({ title, key: title }))" v-slot="{ activeTabIndex }">
        <Highcharts :options="buildConfig(activeTabIndex, activeTabIndex === 1)" />
    </ChartTabs>
</template>
